import * as React from 'react';
import {Route, Switch, useRouteMatch} from "react-router";
import SearchTherapySessions from "./Search";
import AddTherapySession from "./Add";
import ViewTherapySession from "./View";
import AddClientTherapySession from "./AddClient";




const ManageTherapySessions: React.FunctionComponent = () => {
    let {path} = useRouteMatch();
    return (<>
        <Switch>

            <Route exact path={path}>
                <SearchTherapySessions />
            </Route>
            <Route exact path={path + "/add"}>
                <AddTherapySession />
            </Route>
            <Route exact path={path + "/view/:id"}>
                <ViewTherapySession />
            </Route>
            <Route exact path={path + "/add-client/:id"}>
                <AddClientTherapySession />
            </Route>
        </Switch>
    </>);
};

export default ManageTherapySessions;